import { ValidatorFn, ValidationErrors, FormGroup } from "@angular/forms";
import { COUNTRIES_WITH_REQUIRED_INFO } from "../../constants";

export function CountryZipStatementRequired(countryFormControlName: string, mzipFormControlName:string, validatorKey: string): ValidatorFn {

    return (formGroup: FormGroup): ValidationErrors | null => {
      let result: ValidationErrors = null;
      if (COUNTRIES_WITH_REQUIRED_INFO.includes(formGroup.get(countryFormControlName).value) && (!formGroup.get(mzipFormControlName).value)){
        result = {};
        result[validatorKey] = 'fieldValidation.required' ;
      }
      return result;
    };
  
  }